import { useState, useEffect } from "react";
import axios from "axios";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const Chart = () => {
  const [chartData, setChartData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios.get("/api/graphLastTenDays").then((res) => {
      const data = res.data;
      setChartData(data);
    });
    setLoading(false);
  }, []);

  if (loading) return <p style={{ color: "white" }}>...loading</p>;

  const displayData = {
    labels: chartData.dates,
    datasets: [
      {
        label: "Total deep work sessions",
        backgroundColor: "rgb(255, 99, 132)",
        borderColor: "rgb(255, 99, 132)",
        data: chartData.sessions,
      },
    ],
  };

  return (
    <Line
      data={displayData}
      options={{
        scales: {
          y: {
            fontColor: "white",
            beginAtZero: true,
          },
        },
      }}
    />
  );
};

export default Chart;
